import { baseStyle } from '../../shared/styles/baseStyle';

export const modalButton = {
  ...baseStyle.button,
  backgroundColor: 'black',
  marginTop: 50
};
export const img = { padding: 5, marginLeft: -15, backgroundColor: 'white' };
export const marginBottom = { marginBottom: 25, marginTop: 15 };
export const title = {
  marginLeft: -10,
  marginBottom: 0,
  backgroundColor: 'white'
};
